import type { TranslationKey } from '@/i18n-key';

import i18n from '@/plugins/i18n';
import { addMissingTranslationKeyBreadcrumb } from '@/plugins/Sentry';

/**
 * Translates a key that only the runtime can name — an error code returned by the server, a
 * language code read from company settings. Every other key is a literal the compiler checks.
 *
 * Returns `null` when the dictionary does not know the key, so the caller is forced to supply its
 * own wording: a raw key can never reach the screen through this function.
 */
export const translateRuntimeKey = (
    key: string,
    options?: Record<string, unknown>,
): string | null => {
    if (!i18n.exists(key)) {
        addMissingTranslationKeyBreadcrumb(key);
        return null;
    }

    return i18n.t(key as TranslationKey, options);
};
